import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Article.css";
import NavComplete from "../Component/Navbar1";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Alert from "react-bootstrap/Alert";
import Footer from "../Component/footer";
import Card from "react-bootstrap/Card";
import LoadingImage from "../Component/Loadingimage";
import { useRef } from "react";
// {localStorage.getItem("bahasa") === "ing"?``:``}

const Article3 = () => {
  const handleCardClick = (link) => {
    window.location.href = `${link}`;
  };
  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);

  const scrollToPromo = (ref) => {
    const navbarHeight = 88; // Replace with the actual height of your navigation bar
    const rect = ref.current.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetOffset = rect.top + scrollTop - navbarHeight;

    window.scrollTo({
      top: targetOffset,
      behavior: "smooth",
    });
  };
  const togglescroll1 = () => {
    scrollToPromo(section1);
  };
  const togglescroll2 = () => {
    scrollToPromo(section2);
  };
  const togglescroll3 = () => {
    scrollToPromo(section3);
  };
  return (
    <article>
      <div id="containerss">
        <NavComplete />
        <Container
          className="info-page"
          style={{
            color: "white",
            marginTop: "80px",
            marginBottom: "80px",
            maxWidth: "900px",
            fontFamily: "nunito",
          }}
        >
          <Breadcrumb>
            <Breadcrumb.Item href="/Informasi">Blog</Breadcrumb.Item>
            <Breadcrumb.Item active>
              {localStorage.getItem("bahasa") === "ing"
                ? `3 Secrets to Remove Scratches on Car Body Surfaces`
                : `3 Rahasia Menghilangkan Baret Pada Permukaan Body Mobil`}
            </Breadcrumb.Item>
          </Breadcrumb>
          <Row>
            <Col>
              <h1 style={{ fontFamily: "raleway" }}>
                {localStorage.getItem("bahasa") === "ing"
                  ? `3 Secrets to Remove Scratches on Car Body Surfaces`
                  : `3 Rahasia Menghilangkan Baret Pada Permukaan Body Mobil`}
              </h1>
              <div style={{ marginBottom: "15px", gap: "20px" }}>
                <i style={{ padding: "0px 2px" }} class="bi bi-person"></i>
                <a
                  style={{ padding: "0px 5px", marginRight: "10px" }}
                  target="blank_"
                  href="https://www.instagram.com/rezzaalviansyah/"
                >
                  Rezza
                </a>
                <i
                  style={{ padding: "0px 2px" }}
                  class="bi bi-calendar4-week"
                ></i>
                <span style={{ padding: "0px 5px" }}>25 oktober 2023</span>
              </div>
              <img
                src="https://i.ibb.co.com/0sM5KT5/mobil-lecet.webp"
                alt="stracehs-car"
                className="info-image"
              />
              <Alert
                variant="dark"
                style={{
                  background:
                    "linear-gradient(156deg, rgba(0,0,0,1) 41%, rgba(250,0,8,1) 120%)",
                  color: "white",
                  borderColor: "red",
                }}
              >
                <h3>
                  {localStorage.getItem("bahasa") === "ing"
                    ? "Article Content: "
                    : "Isi Artikel: "}
                  {localStorage.getItem("bahasa") === "ing"
                    ? `3 Secrets to Remove Scratches on Car Body Surfaces`
                    : `3 Rahasia Menghilangkan Baret Pada Permukaan Body Mobil`}
                </h3>
                <ul>
                  <li onClick={togglescroll1}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Compound"
                      : "Compound"}
                  </li>
                  <li onClick={togglescroll2}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Coating"
                      : "Coating"}
                  </li>
                  <li onClick={togglescroll3}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Detailing"
                      : "Detailing"}
                  </li>
                </ul>
              </Alert>
              <div style={{ textAlign: "start" }}>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? `Scratches on the surface of the car really ruin the aesthetics and beauty of our car. Especially if you are a perfectionist, it must be really annoying when the surface of your car body is scuffed.`
                    : `Baret pada permukaan mobil benar-benar merusak estetika dan keindahan mobil kita. Apalagi kalo kamu termasuk tipikal orang yang perfeksionis gitu, pasti jengkel banget ketika permukaan body mobil kamu lecet.`}
                </p>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? `There are many reasons for the appearance of scratches on the surface of the car body, such as abrasions due to collisions, gravel on the road, and many other causes. Even though you have tried your best to maintain your car, sometimes scratches on the surface of the car body still appear.`
                    : `Penyebab munculnya baret pada permukaan body mobil juga banyak, seperti lecet karena benturan, kerikil di jalanan, dan masih banyak penyebab lainnya. Meskipun kamu sudah berusaha semaksimal mungkin menjaga dan merawat mobil kamu, kadang baret pada permukaan body mobil tetap saja muncul.`}
                </p>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? `But now you don't have to worry if your car's body surface is scratched, because scratches on the surface of the car body can be resolved in 3 ways. If you really want to take care of the beauty of your car, take a good look at the 3 secrets to removing scratches on the surface of the car body below!`
                    : `Tapi sekarang kamu nggak perlu khawatir kalo permukaan body mobil kamu baret, karena baret pada permukaan body mobil bisa diatasi dengan 3 cara ini. Kalo kamu bener-benar ingin merawat keindahan mobil kamu, simak baik-baik 3 rahasia menghilangkan baret pada permukaan body mobil di bawah ini ya!`}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section1}>
                <b>
                  <h2 style={{ marginBottom: "20px" }}>
                    1.
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Compound"
                      : "Compound"}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/WVcRLTd/Compound.webp"
                  alt="compoundning-car"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `You can overcome the scratches that appear on the surface of your car body with a compound. The compound itself is a solid cream. Usually used in the car painting process.`
                      : `Kamu bisa mengatasi baret yang muncul pada permukaan body mobil kamu dengan compound. Nah compound sendiri merupakan krim yang bersifat padat. Biasanya digunakan pada proses pengecatan mobil. `}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Compound can be the most appropriate choice to restore the scratched surface of your car body. All you have to do is apply the compound correctly, and the scratches will disappear.`
                      : `Compound bisa menjadi pilihan yang paling tepat untuk mengembalikan permukaan body mobil kamu yang baret. Permukaan body mobil yang tergores tinggal kamu oleskan compound dengan benar, maka baretnya akan hilang.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `The abrasive nature of the compound can disguise fine scratches on the car paint. In addition, compound also has other functions, and is commonly used to smooth rough paint layers, after the car painting process.`
                      : `Sifatnya abrasif pada compound mampu menyamarkan baret atau goresan halus pada cat mobil. Selain itu, compound juga memiliki fungsi lainnya, dan biasa digunakan untuk menghaluskan lapisan cat yang kasar, setelah proses pengecatan mobil.`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section2}>
                <b>
                  <h2 style={{ marginBottom: "20px" }}>
                    2.
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Coating"
                      : "Coating"}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/swPR4n7/coating-image.webp"
                  alt="Coating-car"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `If you're one of those people who don't care after your car has been rained on, you need to change that habit because it's one of the causes of mold or water spots on your car's paint and glass surfaces.`
                      : `Belakangan ini, bisnis salon mobil sedang menjamur, terutama salon mobil yang menawarkan teknik coating. Munculnya salon mobil ini lebih karena banyaknya permintaan dari para pemilik mobil yang ingin mobilnya terlihat kinclong dan mengkilap.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `For those of you who are confused, the car coating technique is a new method or a new way of treating the car body with a special coating made of silicon dioxide, aka SiO2. SiO2 itself is the basic material for making ceramics and glass. So, the chemical-based coating, which was originally liquid, will harden over time.`
                      : `Bagi kamu yang bingung, teknik coating mobil merulakan metode baru atau cara baru merawat body mobil dengan lapisan khusus yang terbuat dari silikon dioksida alias SiO2. Nah, SiO2 sendiri adalah bahan dasar untuk membuat keramik dan kaca. Jadi, lapisan berbahan kimia yang semula berbentuk cair itu, seiring berjalannya waktu akan mengeras.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `When it hardens, the SiO2 layer is able to protect the paint or surface of the car body to become more scratch-resistant, the car body is difficult to grow mold, and the color of the car is shinier than usual.`
                      : `Di saat mengeras itulah maka lapisan SiO2 mampu memproteksi cat atau permukaan body mobil menjadi lebih tahan goresan, body mobil sulit tumbuh jamur, sampai warna mobil yang lebih mengkilap daripada biasanya.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `So actually, if you are among those who are busy with work and don't even take care of your car, you can leave your car to a car beauty salon for coating. So, your car stays shiny and shiny and free from mold and scratches.`
                      : `Jadi sebenarnya, kalo kamu termasuk yang sibuk dengan kerjaan bahkan sampai perawatan mobil itu nggak ke pegang, kamu bisa menitipkan mobil kamu ke salon kecantikan mobil untuk dicoating. Sehingga, mobil kamu tetap kinclong dan mengkilap dan terbebas dari  jamur dan baret.`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section3}>
                <b>
                  <h2 style={{ marginBottom: "20px" }}>
                    3.
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Detailing"
                      : "Detailing"}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/zsPH7T1/detailing-machine.jpg"
                  alt="detailing-car"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `In car polishing techniques, apart from coating, there is also detailing. So, detailing is a maintenance technique to beautify the car so that your vehicle looks more perfect and shiny. Unlike coating, which only focuses on the exterior of the car, detailing also focuses on the interior of the car.`
                      : `Dalam teknik poles mobil, selain coating ada juga yang namanya detailing. Jadi, detailing itu merupakan teknik perawatan untuk mempercantik mobil sehingga kendaraan kamu terlihat lebih sempurna dan mengkilap. Berbeda dengan coating yang hanya fokus pada bagian eksterior mobil, detailing ini juga berfokus hingga ke bagian interior mobil.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Car detailing is a more complicated and complex process. This is because this technique will handle all parts of the car, including the engine, if needed at any time.`
                      : `Detailing mobil memiliki proses yang lebih rumit dan kompleks. Karena teknik ini akan menangani semua bagian-bagian yang terdapat pada mobil, termasuk bagian mesin, jika sewaktu-waktu hal tersebut dibutuhkan.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Those are the 3 secrets to removing scratches on the surface of your car body. You just have to adjust it to your economic situation. If you are one of those who are busy working and forget to take care of your vehicle, you can leave your car for coating or detailing.`
                      : `Itu dia 3 rahasia menghilangkan baret pada permukaan body mobil kamu. Tinggal kamu sesuaikan saja dengan keadaan ekonomi kamu. Kalo kamu termasuk yang sibuk kerja sampai lupa merawat kendaraan, kamu bisa menitipkan mobil kamu untuk dicoating atau pun didetailing.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Well one of the car beauty salons that is affordable, pocket-friendly, and the service makes you stunned is We Car Care Car Salon located at Jl. H. Samali No.2 Rt.013/001 Pejaten Barat Pasar Minggu Jakarta, Indonesia. Now you know that beauty costs money, including when it comes to your vehicle.`
                      : `Nah salah satu salon kecantikan mobil yang harganya affordable, ramah di kantong, dan pelayanannya bikin kamu bengong adalah Salon Mobil We Car Care yang terletak di Jl. H. Samali No.2 Rt.013/001 Pejaten Barat Pasar Minggu Jakarta, Indonesia. Sekarang kamu tahu kan, kalo cantik itu butuh biaya, termasuk dalam urusan kendaraan.`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Card
            className="bg-dark "
            style={{
              position: "relative",
              overflow: "hidden",
              alignSelf: "center",
            }}
            onClick={() => handleCardClick("/layanan-harga")}
          >
            <LoadingImage
              src="https://i.ibb.co.com/cgMDvsz/Coating-image.jpg"
              alt="Card image"
              className="card-overlay"
            />
            <Card.ImgOverlay
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "start",
                flexDirection: "column",
                color: "red",
              }}
            >
              <Card.Title>
                <b>Detailing</b>
              </Card.Title>
              <Card.Text
                style={{ backdropFilter: "blur(2px)", fontFamily: "raleway" }}
              >
                {localStorage.getItem("bahasa") === "ing"
                  ? ` Solve your car problem at Wecarcare.`
                  : `Selesaikan masalah mobil mu di Wecarcare`}
              </Card.Text>
            </Card.ImgOverlay>
          </Card>
        </Container>
        <Footer />
      </div>
    </article>
  );
};

export default Article3;
